export enum ESerpMetric {
    ORGANIC = "organic",
    PAID = "paid",
    CPC = "cpc",
}

export interface ISerpRowsConfigs {
    id: ESerpMetric;
    title: string;
    tooltip: string;
    displayNoData?: boolean;
}
